// A utility function to ensure a switch is handling all the cases
// Throws a buildtime error if that's not the case.

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ensureExhaustive = (_: never): unknown => {
  throw new Error("Switch is not exhaustive");
};

export { ensureExhaustive };
